// Money formatting happens only here, at the display edge. Everything upstream
// keeps money as integer minor units (pence). We divide by 100 solely to render.

/** Format integer minor units as a currency string, for example 120000 -> "£1,200.00". */
export function formatMoney(minorUnits: number, currency = "GBP"): string {
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(minorUnits / 100);
}

/** A compact signed form for deltas, for example -30000 -> "-£300.00". */
export function formatSignedMoney(minorUnits: number, currency = "GBP"): string {
  const sign = minorUnits < 0 ? "-" : "";
  return `${sign}${formatMoney(Math.abs(minorUnits), currency)}`;
}

const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** Turn a YYYY-MM string into a short label, for example "2026-07" -> "Jul 2026". */
export function formatMonthLabel(month: string): string {
  const [year, monthNumber] = month.split("-").map(Number);
  const name = MONTH_NAMES[(monthNumber ?? 1) - 1] ?? month;
  return `${name} ${year}`;
}

/** A still shorter month label without the year, for example "Jul". */
export function formatMonthShort(month: string): string {
  const monthNumber = Number(month.split("-")[1]);
  return MONTH_NAMES[monthNumber - 1] ?? month;
}
